import { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import Checkbox from 'src/Admin/components/common/Checkbox';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import {
  stateOptions,
  genderOptions,
  suffixOptions,
  raceOptions,
  relationshipToInsuredOptions,
} from 'src/utils';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { useSelector } from 'react-redux';
import DatePicker from '../../../common/DatePicker';
import moment from 'moment';
import './styles/dependent-info.scss';

const AddDependentInfo = ({
  //nextStep,
  //setAddDepenedentInfoStep,
  //setCurrentStep,
  prevStep,
  enrollmentFormData,
  setEnrollmentFormData,
  setShowAddDependents,
  dependentsData,
}) => {
  console.log('dependentsData AddDependentInfo', dependentsData);
  console.log('enrollmentFormData AddDependentInfo', enrollmentFormData);
  const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  const digitsOnly = (value) => (value ? /^\d+$/.test(value) : true);
  const ONLYSPACES = /^(?!\s+$).*/;
  const ALPHANUMERICONLY = /^[A-Za-z0-9]*$/;
  const ALPHANUMERICWITHSPACE = /^[A-Za-z0-9. ]*$/;
  const formattedSuffixOptions = [...suffixOptions].map((v) => {
    return { label: v.suffixTitle, value: v.suffix };
  });

  const formattedGenderOptions = [...genderOptions].map((v) => {
    return { label: v.genderTitle, value: v.gender };
  });

  const formattedRaceOptions = [...raceOptions].map((v) => {
    return { label: v.raceTitle, value: v.race };
  });

  const formattedRelationshipToInsuredOptions = [
    ...relationshipToInsuredOptions,
  ].map((relationship) => {
    return {
      label: relationship.Description,
      value: relationship.Abbreviation,
    };
  });

  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );
  const [displayDate, setDisplayDate] = useState(null);

  const formattedStateOptions = [...stateOptions].map((v) => {
    return { label: v.stateTitle, value: v.State };
  });
  const [useDifferentMailingAddress, setUseDifferentMailingAddress] =
    useState(false);

  const validationSchema = yup.object({
    personal_suffix: yup.string(),
    personal_first_name: yup
      .string()
      .max(35, 'Enter maximum 35 characters only')
      .required('Enter first name')
      .nullable()
      .matches(ONLYSPACES, 'Enter First Name'),
    personal_middle_name: yup
      .string()
      .max(25, 'Enter maximum 25 characters only'),
    personal_last_name: yup
      .string()
      .max(60, 'Enter maximum 60 characters only')
      .required('Enter Last Name')
      .nullable()
      .matches(ONLYSPACES, 'Enter Last Name'),
    personal_dob: yup.string().required('Enter Date of Birth'),
    personal_gender: yup.string().required('Enter Gender'),
    personal_race: yup.string(),
    personal_relationship: yup
      .string()
      .required('Enter Relationship to Insured'),
    personal_ssn: yup
      .string()
      .matches(
        ALPHANUMERICONLY,
        ' Invalid field - only Alphabets and Numbers allowed.',
      )
      .max(10, ' Maximum 10 characters are allowed'),
    primary_email: yup
      .string()
      .email('Enter Valid Email Address')
      .required('Enter Email Address'),
    alternate_email: yup.string().email('Enter Valid Email Address'),
    mobile_phone: yup.string().matches(phoneRegExp, 'Enter Valid Phone Number'),
    home_phone: yup.string().matches(phoneRegExp, 'Enter Valid Phone Number'),
    work_phone: yup.string().matches(phoneRegExp, 'Enter Valid Phone Number'),
    work_phone_ext: yup
      .string()
      .max(5, 'Enter maximum 5 digits only')
      .test('Digits only', 'The field should have digits only', digitsOnly),
    residence_street: yup
      .string()
      .max(55, 'Enter maximum 55 characters only')
      .required('Enter Street Address')
      .nullable()
      .matches(ONLYSPACES, 'Enter Street Address'),
    residence_apartment: yup
      .string()
      .max(55, 'Enter maximum 55 characters only'),
    residence_city: yup
      .string()
      .max(30, 'Enter maximum 30 characters only')
      .required('Enter City')
      .nullable()
      .matches(ONLYSPACES, 'Enter City'),
    residence_state: yup.string().required('Enter State'),
    residence_zip: yup
      .string()
      .max(15, 'Enter maximum 15 characters only')
      .required('Enter Postal Code')
      .nullable()
      .matches(ONLYSPACES, 'Enter Postal Code'),
    mailing_street: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(55, 'Enter maximum 55 characters only')
            .required('Enter Street Address')
            .nullable()
            .matches(ONLYSPACES, 'Enter Street Address'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(55, 'Enter maximum 55 characters only'),
      }),
    mailing_apartment: yup.string().max(55, 'Enter maximum 55 characters only'),
    mailing_city: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(30, 'Enter maximum 30 characters only')
            .required('Enter City')
            .nullable()
            .matches(ONLYSPACES, 'Enter City'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(30, 'Enter maximum 30 characters only'),
      }),
    mailing_state: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () => yup.string().required('Enter State'),
        otherwise: () => yup.string().notRequired(),
      }),
    mailing_zip: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(15, 'Enter maximum 15 characters only')
            .required('Enter Postal Code')
            .nullable()
            .matches(ONLYSPACES, 'Enter Postal Code'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(15, 'Enter maximum 15 characters only'),
      }),
  });

  const [suffix, setSuffix] = useState('');
  const [gender, setGender] = useState('');
  const [race, setRace] = useState('');
  const [relationship, setRelationship] = useState('');
  const [residenceState, setResidenceState] = useState('');
  const [mailingResidenceState, setMailingResidenceState] = useState('');
  const [dobValue, setDobValue] = useState(false);

  const selectedSuffix = formattedSuffixOptions.filter(
    (option) => option.value === suffix,
  );

  const selectedGender = formattedGenderOptions.filter(
    (option) => option.value === gender,
  );

  const selectedRace = formattedRaceOptions.filter(
    (option) => option.value === race,
  );

  const selectedRelationship = formattedRelationshipToInsuredOptions.filter(
    (option) => option.value === relationship,
  );

  const selectedResidenceState = formattedStateOptions.filter(
    (option) => option.value === residenceState,
  );

  const selectedMailingResidenceState = formattedStateOptions.filter(
    (option) => option.value === mailingResidenceState,
  );

  const initialValues = {
    personal_suffix: '',
    personal_first_name: '',
    personal_middle_name: '',
    personal_last_name: '',
    personal_dob: '',
    personal_gender: '',
    personal_race: '',
    personal_relationship: '',
    personal_ssn: '',
    primary_email: '',
    alternate_email: '',
    mobile_phone: '',
    home_phone: '',
    work_phone: '',
    work_phone_ext: '',
    residence_street: '',
    residence_apartment: '',
    residence_city: '',
    residence_state: '',
    residence_zip: '',
    mailing_street: '',
    mailing_apartment: '',
    mailing_city: '',
    mailing_state: '',
    mailing_zip: '',
  };

  const handlePersonalSuffixSelection = (e) => {
    setSuffix(e.value);
  };

  const handlePersonalGenderSelection = (e) => {
    setGender(e.value);
  };

  const handlePersonalRaceEthnicitySelection = (e) => {
    setRace(e.value);
  };

  const handlePersonalRelationshipSelection = (e) => {
    setRelationship(e.value);
  };

  const handlePersonalResidenceStateSelection = (e) => {
    setResidenceState(e.value);
  };
  const handlePersonalMailingResidenceStateSelection = (e) => {
    setMailingResidenceState(e.value);
  };
  const generateDependentSequenceNumber = () => {
    const mergeArray = [
      ...dependentsData,
      ...enrollmentFormData.removedExistingDependent,
    ];
    const maxSequenceNumber = mergeArray.reduce((acc, value) => {
      return (acc =
        acc > value.DepSequenceNumber ? acc : value.DepSequenceNumber);
    }, 0);
    return maxSequenceNumber + 1;
  };

  const unFormatPhoneNumber = (phone) => {
    if (phone !== null || phone.toString() !== '') {
      return phone
        .toString()
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '$1$2$3');
    }
  };

  const getFormattedNewlyAddedDependent = (userValues) => {
    return {
      DependentNewlyAdded: true,
      //DepSequenceNumber: dependentsData.length + 1,
      DepSequenceNumber: generateDependentSequenceNumber(),
      dependentsInfoLoaded: true,
      dependentsAPIError: false,
      DepLastName: userValues.personal_last_name || '',
      DepFirstName: userValues.personal_first_name || '',
      RelationshipToEmployee: userValues.personal_relationship,
      Status: '',
      DependentsInformation: {
        Suffix: userValues.personal_suffix || null,
        Gender: userValues.personal_gender,
        LastName: userValues.personal_last_name || '',
        FirstName: userValues.personal_first_name || '',
        BirthDate: userValues.personal_dob,
        MiddleName: userValues.personal_middle_name || null,
        NumberOfDependents: null,
        SocialSecurityNumber: userValues.personal_ssn,
        Family: false,
        AlternateID1: null,
        AlternateID2: '',
        MemberID: '',
        CertificateNumber: '',
        Age: '',
        Status: null,
        Race: userValues.personal_race,
      },
      DependentResidentailAddress: `${userValues.residence_street} ${userValues.residence_apartment}${userValues.residence_city}, ${userValues.residence_state}`,
      DependentMailingAddress: userValues.mailing_street
        ? `${userValues.mailing_street} ${userValues.mailing_apartment}, ${userValues.mailing_city}, ${userValues.mailing_state}`
        : `${userValues.residence_street} ${userValues.residence_apartment}${userValues.residence_city}, ${userValues.residence_state}`,
      DependentResidentailAddressZip: `${userValues.residence_zip} USA `,
      DependentMailingAddressZip: userValues.mailing_zip
        ? `${userValues.mailing_zip} USA `
        : `${userValues.residence_zip} USA `,
      PhoneEmailInfo: {
        WorkPhone: userValues.work_phone
          ? unFormatPhoneNumber(userValues.work_phone)
          : '',
        MobilePhone: userValues.mobile_phone
          ? unFormatPhoneNumber(userValues.mobile_phone)
          : '',
        HomePhone: userValues.home_phone
          ? unFormatPhoneNumber(userValues.home_phone)
          : '',
        Email1: userValues.primary_email,
        Email2: userValues.alternate_email,
      },
    };
  };

  const formatPhone = (e) => {
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
      target.value = `(${first}) ${middle} ${last}`;
    } else if (input.length > 3) {
      target.value = `(${first}) ${middle}`;
    } else if (input.length > 0) {
      target.value = `(${first})`;
    }
  };

  const handleBlurDatePicker = (dateValue) => {
    if (dateValue && dateValue !== '') {
      setDobValue(false);
    } else {
      setDobValue(true);
    }
  };

  return (
    <div>
      <Row>
        <Col md="12">
          <div className="my-profile-member-container">
            <div
              className="row-title-header"
              style={{ justifyContent: 'space-between' }}
            >
              <div>
                <h2 className="row-title" tabIndex={0}>
                  Add Dependent
                </h2>
              </div>
            </div>
            <Formik
              validateOnMount={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                const submittedValues = {
                  ...values,
                  personal_suffix: suffix,
                  personal_gender: gender,
                  personal_race: race,
                  personal_relationship: relationship,
                  residence_state: residenceState,
                  mailing_state: mailingResidenceState,
                };
                console.log('submiited values', submittedValues);
                //setAddDepenedentInfoStep(false);
                //nextStep();
                //setCurrentStep(2);
                //prevStep();
                const newlyAddedDepdentDetails =
                  getFormattedNewlyAddedDependent(submittedValues);
                console.log(
                  'Newly added dependent >>>>>>>>>>>>>>  ',
                  newlyAddedDepdentDetails,
                );
                setEnrollmentFormData({
                  ...enrollmentFormData,
                  newDependentInfoFields: [
                    ...enrollmentFormData.newDependentInfoFields,
                    submittedValues,
                  ],
                  newlyAddedDependent: [newlyAddedDepdentDetails],
                  allNewlyAddedDependent: [
                    ...enrollmentFormData.allNewlyAddedDependent,
                    newlyAddedDepdentDetails,
                  ],
                });
                setShowAddDependents(false);
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                isValid,
                handleReset,
                resetForm,
                setFieldTouched,
                setValues,
                setFieldValue,
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="form-main-container">
                      <div className="p-0 m-0 mb-2 mt-4 ml-3 form-section">
                        Personal Information
                      </div>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Suffix</Form.Label>
                            <AutoSuggestionSelectComponent
                              options={formattedSuffixOptions}
                              name="personal_suffix"
                              placeholder="Select"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              value={selectedSuffix || null}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'personal_suffix', value: e },
                                };
                                handleChange(event);
                                handlePersonalSuffixSelection(e);
                                setFieldValue('personal_suffix', e.value);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.personal_suffix &&
                                errors.personal_suffix
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isInvalid={
                                touched.personal_suffix &&
                                errors.personal_suffix
                              }
                            />
                            <div className="invalid-error-feedback">
                              <span role="alert">
                                {touched.personal_suffix &&
                                  errors.personal_suffix}
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              First Name
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="personal_first_name"
                              placeholder=""
                              className=""
                              value={values.personal_first_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.personal_first_name &&
                                errors.personal_first_name
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.personal_first_name &&
                                  errors.personal_first_name}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Middle Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="personal_middle_name"
                              placeholder=""
                              className=""
                              value={values.personal_middle_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.personal_middle_name &&
                                errors.personal_middle_name
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.personal_middle_name &&
                                  errors.personal_middle_name}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Last Name
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="personal_last_name"
                              placeholder=""
                              className=""
                              value={values.personal_last_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.personal_last_name &&
                                errors.personal_last_name
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.personal_last_name &&
                                  errors.personal_last_name}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Date of Birth
                              <span className="form-required">*</span>
                            </Form.Label>
                            {/*<Form.Control
                              type="date"
                              name="personal_dob"
                              placeholder="MM/DD/YYYY"
                              className=""
                              value={values.personal_dob}
                              max={new Date().toISOString().split('T')[0]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.personal_dob && errors.personal_dob
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            /> */}
                            <DatePicker
                              name={'personal_dob'}
                              showIcon={true}
                              isDOB={true}
                              value={values.personal_dob ? displayDate : null}
                              onBlur={() =>
                                handleBlurDatePicker(values.personal_dob)
                              }
                              onChange={(date) => {
                                if (date) {
                                  setFieldValue(
                                    'personal_dob',
                                    moment(date).format('YYYY-MM-DD'),
                                  );
                                  setDisplayDate(date);
                                  setDobValue(false);
                                } else {
                                  setFieldValue('personal_dob', '');
                                  setDobValue(true);
                                }
                              }}
                              errorClassName={
                                dobValue ? 'invalid-error-border' : ''
                              }
                            />
                            {dobValue && (
                              <div className="invalid-feedback-error">
                                <span role="alert">{errors.personal_dob}</span>
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Gender
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={formattedGenderOptions}
                              name="personal_gender"
                              placeholder="Select"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              value={selectedGender || null}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'personal_gender', value: e },
                                };
                                handleChange(event);
                                handlePersonalGenderSelection(e);
                                setFieldValue('personal_gender', e.value);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.personal_gender &&
                                errors.personal_gender
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isInvalid={
                                touched.personal_gender &&
                                errors.personal_gender
                              }
                            />
                            <div className="invalid-error-feedback">
                              <span role="alert">
                                {touched.personal_gender &&
                                  errors.personal_gender}
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Race/Ethnicity</Form.Label>
                            <AutoSuggestionSelectComponent
                              options={formattedRaceOptions}
                              name="personal_race"
                              placeholder="Select"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              value={selectedRace || null}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'personal_race', value: e },
                                };
                                handleChange(event);
                                handlePersonalRaceEthnicitySelection(e);
                                setFieldValue('personal_race', e.value);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.personal_race && errors.personal_race
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isInvalid={
                                touched.personal_race && errors.personal_race
                              }
                            />
                            <div className="invalid-error-feedback">
                              <span role="alert">
                                {touched.personal_race && errors.personal_race}
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Relationship to insured
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={formattedRelationshipToInsuredOptions}
                              name="personal_relationship"
                              placeholder="Select"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              value={selectedRelationship || null}
                              onChange={(e) => {
                                const event = {
                                  target: {
                                    name: 'personal_relationship',
                                    value: e,
                                  },
                                };
                                handleChange(event);
                                handlePersonalRelationshipSelection(e);
                                setFieldValue('personal_relationship', e.value);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.personal_relationship &&
                                errors.personal_relationship
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isInvalid={
                                touched.personal_relationship &&
                                errors.personal_relationship
                              }
                            />
                            <div className="invalid-error-feedback">
                              <span role="alert">
                                {touched.personal_relationship &&
                                  errors.personal_relationship}
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Social Security Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="personal_ssn"
                              placeholder=""
                              className=""
                              value={values.personal_ssn}
                              maxLength={10}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.personal_ssn && errors.personal_ssn
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.personal_ssn && errors.personal_ssn}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="p-0 m-0 mb-2 mt-4 ml-3 form-section">
                        Contact Information
                      </div>
                      <Row className="m-0">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label>
                              Email
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="primary_email"
                              placeholder=""
                              className=""
                              value={values.primary_email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.primary_email && errors.primary_email
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.primary_email && errors.primary_email}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label>Alternative Email</Form.Label>
                            <Form.Control
                              type="text"
                              name="alternate_email"
                              placeholder=""
                              className=""
                              value={values.alternate_email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.alternate_email &&
                                errors.alternate_email
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.alternate_email &&
                                  errors.alternate_email}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Mobile Phone</Form.Label>
                            <div className="d-flex">
                              <Col md={1} xs={1} className="no-padd">
                                <Form.Control
                                  type="text"
                                  name="countryCode"
                                  placeholder=""
                                  className="countrycode-width"
                                  value="+1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                  readOnly={true}
                                />
                              </Col>
                              <Col md={11} xs={11} className="contact-number">
                                <Form.Control
                                  type="text"
                                  name="mobile_phone"
                                  placeholder=""
                                  className=""
                                  value={values.mobile_phone}
                                  maxLength={14}
                                  onKeyUp={(e) => formatPhone(e)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.mobile_phone && errors.mobile_phone
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.mobile_phone &&
                                      errors.mobile_phone}
                                  </span>
                                </Form.Control.Feedback>
                              </Col>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Home Phone</Form.Label>
                            <div className="d-flex">
                              <Col md={1} xs={1} className="no-padd">
                                <Form.Control
                                  type="text"
                                  name="countryCode"
                                  placeholder=""
                                  className="countrycode-width"
                                  value="+1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                  readOnly={true}
                                />
                              </Col>
                              <Col md={11} xs={11} className="contact-number">
                                <Form.Control
                                  type="text"
                                  name="home_phone"
                                  placeholder=""
                                  className=""
                                  value={values.home_phone}
                                  maxLength={14}
                                  onKeyUp={(e) => formatPhone(e)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.home_phone && errors.home_phone
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.home_phone && errors.home_phone}
                                  </span>
                                </Form.Control.Feedback>
                              </Col>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6} xs={6}>
                          <Form.Group>
                            <Form.Label>Work Phone</Form.Label>
                            <div className="d-flex">
                              <Col md={1} xs={1} className="no-padd">
                                <Form.Control
                                  type="text"
                                  name="workCountryCode"
                                  placeholder=""
                                  className="countrycode-width"
                                  value="+1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                  readOnly={true}
                                />
                              </Col>
                              <Col
                                md={11}
                                xs={11}
                                className="contact-number work-phone-contact"
                              >
                                <Form.Control
                                  type="text"
                                  name="work_phone"
                                  placeholder=""
                                  className=""
                                  value={values.work_phone}
                                  maxLength={14}
                                  onKeyUp={(e) => formatPhone(e)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.work_phone && errors.work_phone
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.work_phone && errors.work_phone}
                                  </span>
                                </Form.Control.Feedback>
                              </Col>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md={6} xs={6}>
                          <Form.Group>
                            <Form.Label className="form-label-extn">
                              Extn
                            </Form.Label>
                            <div className="d-flex">
                              <Col
                                md={12}
                                xs={12}
                                className="contact-number-extn"
                              >
                                <Form.Control
                                  type="text"
                                  name="work_phone_ext"
                                  placeholder=""
                                  className=""
                                  value={values.work_phone_ext}
                                  maxLength={14}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.work_phone_ext &&
                                    errors.work_phone_ext
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.work_phone_ext &&
                                      errors.work_phone_ext}
                                  </span>
                                </Form.Control.Feedback>
                              </Col>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="p-0 m-0 mb-2 mt-4 ml-3 form-section">
                        Residential Address
                      </div>
                      <Row className="m-0">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label>
                              Street Address
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="residence_street"
                              placeholder=""
                              className=""
                              value={values.residence_street}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.residence_street &&
                                errors.residence_street
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.residence_street &&
                                  errors.residence_street}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label>Apartment/Suit</Form.Label>
                            <Form.Control
                              type="text"
                              name="residence_apartment"
                              placeholder=""
                              className=""
                              value={values.residence_apartment}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.residence_apartment &&
                                errors.residence_apartment
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.residence_apartment &&
                                  errors.residence_apartment}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              City
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="residence_city"
                              placeholder=""
                              className=""
                              value={values.residence_city}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.residence_city && errors.residence_city
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.residence_city &&
                                  errors.residence_city}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              State
                              <span className="form-required">*</span>
                            </Form.Label>
                            <AutoSuggestionSelectComponent
                              options={formattedStateOptions}
                              name="residence_state"
                              placeholder="Select State"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              value={selectedResidenceState || null}
                              onChange={(e) => {
                                const event = {
                                  target: { name: 'residence_state', value: e },
                                };
                                handleChange(event);
                                handlePersonalResidenceStateSelection(e);
                                setFieldValue('residence_state', e.value);
                              }}
                              fieldTouch={setFieldTouched}
                              //isSearchable={false}
                              inputClassName={
                                touched.residence_state &&
                                errors.residence_state
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isInvalid={
                                touched.residence_state &&
                                errors.residence_state
                              }
                            />
                            <div className="invalid-error-feedback">
                              <span role="alert">
                                {touched.residence_state &&
                                  errors.residence_state}
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              Zip
                              <span className="form-required">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="residence_zip"
                              placeholder=""
                              className=""
                              value={values.residence_zip}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.residence_zip && errors.residence_zip
                              }
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.residence_zip && errors.residence_zip}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col md={12} className="different-address">
                          <Checkbox
                            label={'Use a different mailing address'}
                            checked={useDifferentMailingAddress}
                            onChange={(e) => {
                              setUseDifferentMailingAddress(e.target.checked);
                              setTimeout(() => {
                                if (!e.target.checked) {
                                  setFieldValue('mailing_street', '');
                                  setFieldValue('mailing_apartment', '');
                                  setFieldValue('mailing_city', '');
                                  setFieldValue('mailing_state', '');
                                  setFieldValue('mailing_zip', '');
                                  setMailingResidenceState('');
                                }
                              }, 1000);
                            }}
                          />
                        </Col>
                      </Row>
                      {useDifferentMailingAddress && (
                        <>
                          <Row className="m-0 mt-4">
                            <Col md={12}>
                              <div className="p-0 m-0 mb-1 form-section">
                                Mailing Address
                              </div>
                              <Form.Group>
                                <Form.Label>
                                  Street Address
                                  <span className="form-required">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="mailing_street"
                                  placeholder=""
                                  className=""
                                  value={values.mailing_street}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.mailing_street &&
                                    errors.mailing_street
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.mailing_street &&
                                      errors.mailing_street}
                                  </span>
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className="m-0">
                            <Col md={12}>
                              <Form.Group>
                                <Form.Label>Apartment/Suit</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="mailing_apartment"
                                  placeholder=""
                                  className=""
                                  value={values.mailing_apartment}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.mailing_apartment &&
                                    errors.mailing_apartment
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.mailing_apartment &&
                                      errors.mailing_apartment}
                                  </span>
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className="m-0">
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label>
                                  City
                                  <span className="form-required">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="mailing_city"
                                  placeholder=""
                                  className=""
                                  value={values.mailing_city}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.mailing_city && errors.mailing_city
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.mailing_city &&
                                      errors.mailing_city}
                                  </span>
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label>
                                  State
                                  <span className="form-required">*</span>
                                </Form.Label>
                                <AutoSuggestionSelectComponent
                                  options={formattedStateOptions}
                                  name="mailing_state"
                                  placeholder="Select State"
                                  components={{
                                    IndicatorSeparator: () => null,
                                  }}
                                  value={selectedMailingResidenceState || null}
                                  onChange={(e) => {
                                    const event = {
                                      target: {
                                        name: 'mailing_state',
                                        value: e,
                                      },
                                    };
                                    handleChange(event);
                                    handlePersonalMailingResidenceStateSelection(
                                      e,
                                    );
                                    setFieldValue('mailing_state', e.value);
                                  }}
                                  fieldTouch={setFieldTouched}
                                  //isSearchable={false}
                                  inputClassName={
                                    touched.mailing_state &&
                                    errors.mailing_state
                                      ? 'select-invalid-error'
                                      : ''
                                  }
                                  isInvalid={
                                    touched.mailing_state &&
                                    errors.mailing_state
                                  }
                                />
                                <div className="invalid-error-feedback">
                                  <span role="alert">
                                    {touched.mailing_state &&
                                      errors.mailing_state}
                                  </span>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className="m-0">
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label>
                                  Zip
                                  <span className="form-required">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="mailing_zip"
                                  placeholder=""
                                  className=""
                                  value={values.mailing_zip}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.mailing_zip && errors.mailing_zip
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.mailing_zip && errors.mailing_zip}
                                  </span>
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      )}

                      <Form.Group
                        className="form-block mt-4 mrg-rgt-16"
                        controlId="buttonsFormGroup"
                      >
                        <Row>
                          <Col className="d-flex justify-content-end">
                            <GenericButton
                              variant="link"
                              onClick={() => {
                                resetForm();
                                //setAddDepenedentInfoStep(false);
                                //setCurrentStep(2);
                                //prevStep();
                                setShowAddDependents(false);
                              }}
                              className="form-btn"
                            >
                              Cancel
                            </GenericButton>
                            <GenericButton
                              type="submit"
                              className="mr-0"
                              disable={!isValid}
                              buttonDisabled={!isValid}
                            >
                              Add Dependent
                            </GenericButton>
                          </Col>
                        </Row>
                      </Form.Group>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default AddDependentInfo;
